import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=169cc96a&scoped=true"
import script from "./policy.vue?vue&type=script&lang=js"
export * from "./policy.vue?vue&type=script&lang=js"
import style0 from "./policy.vue?vue&type=style&index=0&id=169cc96a&prod&scoped=true&lang=less"
import style1 from "./policy.vue?vue&type=style&index=1&id=169cc96a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169cc96a",
  null
  
)

export default component.exports